import { encodeFunctionData } from "viem";
import { createMeeClient } from "@biconomy/abstractjs";
import { arbitrum, bsc } from "viem/chains";
import BalanceOfAbi from "../../../src/utils/UsdtABI.json";
import {
  ethNullAddress,
  me_client_api_key,
  USDT_CONTRACT_ADDRESS,
} from "../../utils/Enviroment";
import useWeb3 from "../../hooks/useWeb3";
import { getBalance } from "../../utils/contractHelpers";
import { useRecoilValue } from "recoil";
import {
  userSmartAccount,
  userSmartAccountClient,
} from "../../components/recoilAtom";
import { handleToastErrors } from "../../utils/helpers";
import { signPreparedCalls } from "@account-kit/wallet-client";
import { useSessionPermissions } from "../../hooks/checkSessionPermissions";
import { BigNumber } from "bignumber.js";
import { ethers } from "ethers";
import axios from "axios";

export const useWithdrawalAmountHook = () => {
  const chain = bsc;
  const web3 = useWeb3();
  const smartAccount = useRecoilValue(userSmartAccount);
  const userSmartClient = useRecoilValue(userSmartAccountClient);
  const { grantPermissions } = useSessionPermissions();

  function toWei(etherAmount) {
    // Convert to fixed decimal string first
    const fixedValue = parseFloat(etherAmount).toFixed(18);
    const [integerPart = "0", decimalPart = ""] = fixedValue.split(".");

    // Pad decimal to exactly 18 places
    const paddedDecimal = decimalPart.padEnd(18, "0").substring(0, 18);

    // Combine and convert to BigInt to avoid precision issues
    const wei = BigNumber(integerPart + paddedDecimal);

    return wei.toString();
  }

  const sendGasFeeAsUsdt = (usdtForGas) => {
    const usdtForGasinMwei = ethers.parseUnits(usdtForGas?.toFixed(6), 6);

    const encodedTransferCall = encodeFunctionData({
      abi: BalanceOfAbi,
      functionName: "transfer",
      args: ["0x9f0d847F45e06baeb9e11848040b76E1622406c6", usdtForGasinMwei],
    });
    return encodedTransferCall;
  };

  const ethToDollarConversion = async (dataa) => {
    let balace = await axios.get(
      "https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD"
    );
    let price = balace.data.USD;
    let ethBalance = dataa * price;
    return ethBalance;
  };

  const handleGasFeeWithPreparedCalls = async (
    smartAccountClient,
    smartAccount,
    callArgs
  ) => {
    console.log(smartAccountClient, smartAccount, callArgs, "preparedCalls");
    const preparedCalls = await smartAccountClient.prepareCalls({
      calls: callArgs,
      from: smartAccount,
    });
    console.log(preparedCalls, "preparedCalls");

    const { data } = preparedCalls;
    const callGasLimit = Number(data.callGasLimit);
    const verificationGasLimit = Number(data.verificationGasLimit);
    const preVerificationGas = Number(data.preVerificationGas);
    const maxFeePerGas = Number(data.maxFeePerGas);
    const totalGasLimit =
      callGasLimit + verificationGasLimit + preVerificationGas;
    const totalCostWei = totalGasLimit * maxFeePerGas;
    const totalCostEth = totalCostWei / 1e18;
    const gasFeeInDollars = await ethToDollarConversion(totalCostEth);
    const bufferedGasFee = (gasFeeInDollars * 120) / 100;
    return bufferedGasFee;
  };

  const withdrawalAmountTransaction = async (
    withdrawalAddress,
    withdrawalAmount,
    isUSDT,
    UsdtBalance,
    EthBalance,
    smartAccountt,
    smartAccountClient,
    // permissions,
    // sessionkey,
    publicClient
  ) => {
    console.log(
      withdrawalAddress,
      withdrawalAmount,
      isUSDT,
      UsdtBalance,
      EthBalance,
      smartAccountt,
      smartAccountClient,
      "withdrawal logs"
    );

    let withdrawalAmountInWei = web3.utils.toWei(
      String(withdrawalAmount),
      isUSDT ? "mwei" : "ether"
    );
    if (isUSDT) {
      withdrawalAmountInWei = web3.utils.toWei(
        String(withdrawalAmount),
        "mwei"
      );
    } else {
      withdrawalAmountInWei = toWei(withdrawalAmount);
    }

    const targetABI = BalanceOfAbi;
    // const estimatedGasFee = await calculateGasBuffer(
    //   isUSDT,
    //   withdrawalAddress,
    //   withdrawalAmountInWei
    // );
    // const estimatedTxCost = withdrawalAmountInWei + estimatedGasFee;
    // const isSufficientBalance = isUSDT
    //   ? usdtBalanceInWei > estimatedTxCost
    //   : ethBlanceInWei > estimatedTxCost;

    // if (!isSufficientBalance) {
    //   const message =
    //     "Insufficient balance to cover the withdrawal amount and gas fees.";
    //   handleToastErrors(message);
    //   throw new Error("This is a custom system error");
    // }
    try {
      const { userPermissions: permissions, userSessionKey: sessionKey } =
        await grantPermissions();
      const callArgsbefore = isUSDT
        ? [
            {
              to: USDT_CONTRACT_ADDRESS,
              data: encodeFunctionData({
                abi: targetABI,
                functionName: "transfer",
                args: [
                  withdrawalAddress,
                  web3.utils.toHex(withdrawalAmountInWei),
                ],
              }),
            },
          ]
        : [
            {
              to: withdrawalAddress,
              data: "0x",
              value: web3.utils.toHex(withdrawalAmountInWei),
            },
          ];

      let gasFee = await handleGasFeeWithPreparedCalls(
        smartAccountClient,
        smartAccountt,
        callArgsbefore
      );

      let finallValue = parseFloat(withdrawalAmount) - parseFloat(gasFee);
      finallValue = finallValue.toFixed(6);

      let valuee = web3.utils.toWei(String(finallValue), "mwei");

      const callArgs = isUSDT
        ? [
            {
              to: USDT_CONTRACT_ADDRESS,
              data: encodeFunctionData({
                abi: targetABI,
                functionName: "transfer",
                args: [withdrawalAddress, web3.utils.toHex(valuee)],
              }),
            },
            {
              to: USDT_CONTRACT_ADDRESS,
              data: sendGasFeeAsUsdt(gasFee),
            },
          ]
        : [
            {
              to: withdrawalAddress,
              data: "0x",
              value: web3.utils.toHex(withdrawalAmountInWei),
            },
          ];
      console.log(sendGasFeeAsUsdt(gasFee), "encodedTransferCall");

      const preparedCalls = await smartAccountClient.prepareCalls({
        calls: callArgs,
        from: smartAccountt,
        capabilities: {
          permissions,
        },
      });
      const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
      const sendResult = await smartAccountClient.sendPreparedCalls({
        ...signedCalls,
        capabilities: {
          permissions,
        },
      });

      const { preparedCallIds } = sendResult;
      await new Promise((resolve) => setTimeout(resolve, 10000));
      const status = await smartAccountClient.getCallsStatus(
        preparedCallIds[0]
      );

      const possibleTxHashes = [
        status.transactionHash,
        status.txHash,
        status.hash,
        status.receipt?.transactionHash,
        status.receipts?.[0]?.transactionHash,
        status.userOperationReceipt?.transactionHash,
        status.result?.transactionHash,
        status.data?.transactionHash,
        status.tx,
      ];
      console.log(possibleTxHashes);

      console.log(status);

      const txHash = possibleTxHashes.find((hash) => hash);
      console.log(txHash);
      // await new Promise((resolve) => setTimeout(resolve, 5000));
      // const receipt = await publicClient.getTransactionReceipt({
      //   hash: txHash,
      // });
      return txHash;
    } catch (error) {
      console.error("Error in tx:", error);
      throw error;
    }
  };

  return { withdrawalAmountTransaction };
};
export default useWithdrawalAmountHook;
